import { CommandContribution } from '@patsnap/tahiti-core/common/command';
import { RemoveCustomFieldCommandContribution } from './remove-custom-field-command-contribution';
import { CopyCustomFieldCommandContribution } from './copy-custom-field-command-contribution';
import { EditCustomFieldCommandContribution } from './edit-custom-field-command-contribution';
import { SaveCustomFieldAsPublicCommandContribution } from './save-custom-field-as-public-command-contribution';
import { FieldPermissionCommandContribution } from './field-permission-command-contribution';
import { DefaultPermissionCommandContribution } from './default-permission-command-contribution';
import { bindContributionProvider } from '@patsnap/tahiti-core/common/contribution-provider';
import { CustomFieldActionContribution } from './custom-field-action-contribution.interface';
import { CopyCustomFieldActionContribution } from './copy-custom-field-action-contribution';
import { RemoveCustomFieldActionContribution } from './remove-custom-field-action-contribution';
import { SaveCustomFieldAsPublicActionContribution } from './save-custom-field-as-public-action-contribution';
import { FieldPermissionActionContribution } from './field-permission-action-contribution';
import { DefaultPermissionActionContribution } from './default-permission-action-contribution';
import { CustomFieldActionRegistryImpl } from './custom-field-action-registry';
import { CustomFieldActionRegistry } from './custom-field-action-registry.interface';
import { EditCustomFieldActionContribution } from './edit-custom-field-action-contribution';
import { GroupOrUserInputServiceReaderImpl } from './group-or-user-input-reader';
import { GroupOrUserInputServiceReader } from './group-or-user-input-reader.interface';
import { FieldPermissionDialogService, FieldPermissionDialogServiceSymbol } from '@/presentation/components/field-permission-dialog/FieldPermissionDialogService';
import { DefaultPermissionDialogService, DefaultPermissionDialogServiceSymbol } from '@/presentation/components/default-permission-dialog/DefaultPermissionDialogService';
import { FieldPermissionService } from '@/services/FieldPermissionService';
export function customFieldActionsModule(bind) {
    bind(CommandContribution).to(RemoveCustomFieldCommandContribution);
    bind(CommandContribution).to(CopyCustomFieldCommandContribution);
    bind(CommandContribution).to(EditCustomFieldCommandContribution);
    bind(CommandContribution).to(SaveCustomFieldAsPublicCommandContribution);
    bind(CommandContribution).to(FieldPermissionCommandContribution);
    bind(CommandContribution).to(DefaultPermissionCommandContribution);
    bind(GroupOrUserInputServiceReader).to(GroupOrUserInputServiceReaderImpl);
    // 业务服务
    bind(FieldPermissionService).toSelf().inSingletonScope();
    // 弹窗服务
    bind(FieldPermissionDialogServiceSymbol).to(FieldPermissionDialogService).inSingletonScope();
    bind(DefaultPermissionDialogServiceSymbol).to(DefaultPermissionDialogService).inSingletonScope();
    bindContributionProvider(bind, CustomFieldActionContribution);
    bind(CustomFieldActionRegistry).to(CustomFieldActionRegistryImpl);
    bind(CustomFieldActionContribution).to(CopyCustomFieldActionContribution);
    bind(CustomFieldActionContribution).to(SaveCustomFieldAsPublicActionContribution);
    bind(CustomFieldActionContribution).to(RemoveCustomFieldActionContribution);
    bind(CustomFieldActionContribution).to(EditCustomFieldActionContribution);
    bind(CustomFieldActionContribution).to(FieldPermissionActionContribution);
    bind(CustomFieldActionContribution).to(DefaultPermissionActionContribution);
}
